import Swiper, {Autoplay, Navigation, Pagination, Thumbs} from 'swiper'
/**
 * @param swiperInit
 */
export default function swiperInit() {
	$('.product-list-wrap').each(function (index, ele) {
		console.log(ele)
		const nameItem = 'item-1' + index
		$(this).addClass(nameItem)
		new Swiper(`.${nameItem} .product-list-slide .swiper`, {
			modules: [Navigation, Autoplay],
			slidesPerView: 2,
			autoplay: {
				delay: 2000,
			},
			spaceBetween: 15,
			speed: 1000,
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
				1280: {
					slidesPerView: 3,
					spaceBetween: 60,
				},
			},
			navigation: {
				nextEl: `.${nameItem} .product-list-slide .btn-next`,
				prevEl: `.${nameItem} .product-list-slide .btn-prev`,
			},
		})
	})
	var slideProductThumb
	if (window.matchMedia('(max-width: 1024px)').matches) {
		slideProductThumb = new Swiper(
			'.section-product-detail .product-detail-thumb-mobile .swiper',
			{
				slidesPerView: 2,
				direction: 'horizontal',
				spaceBetween: 10,
				modules: [Navigation],
				observer: true,
				observeParents: true,
				loopedSlides: 5,
				loop: true,
				navigation: {
					prevEl: `.section-product-detail .product-detail-thumb-mobile .up`,
					nextEl: `.section-product-detail .product-detail-thumb-mobile .down`,
				},
				breakpoints: {
					768: {
						direction: 'vertical',
						slidesPerView: 3,
					},
					1024: {
						slidesPerView: 4,
					},
				},
			}
		)
	} else {
		slideProductThumb = new Swiper(
			'.section-product-detail .product-detail-thumb .swiper',
			{
				slidesPerView: 3,
				direction: 'vertical',
				spaceBetween: 10,
				modules: [Navigation],
				observer: true,
				observeParents: true,
				loop: true,
				navigation: {
					prevEl: `.section-product-detail .product-detail-thumb .up`,
					nextEl: `.section-product-detail .product-detail-thumb .down`,
				},
			}
		)
	}

	var slideProductMain = new Swiper(
		'.section-product-detail .product-detail-image .swiper',
		{
			slidesPerView: 1,
			spaceBetween: 30,
		}
	)
	var slideProductOther = new Swiper('.section-product-other .swiper', {
		slidesPerView: 2,
		spaceBetween: 15,
		modules: [Navigation, Autoplay],
		navigation: {
			nextEl: `.section-product-other .btn-next`,
			prevEl: `.section-product-other .btn-prev`,
		},
		autoplay: {
			delay: 2500,
		},
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 4,
				spaceBetween: 30,
			},
		},
	})
	var slideCuisineOther = new Swiper('.section-cuisine-4 .swiper', {
		slidesPerView: 1,
		spaceBetween: 15,
		modules: [Navigation],
		navigation: {
			nextEl: `.section-cuisine-4 .btn-next`,
			prevEl: `.section-cuisine-4 .btn-prev`,
		},
		breakpoints: {
			1024: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 3,
				spaceBetween: 90,
			},
		},
	})
	var slideCuisineOther = new Swiper(
		'.section-news-detail.other-news .swiper',
		{
			slidesPerView: 1,
			spaceBetween: 15,
			modules: [Navigation],
			navigation: {
				nextEl: `.section-news-detail.other-news .btn-next`,
				prevEl: `.section-news-detail.other-news .btn-prev`,
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
					spaceBetween: 30,
				},
				1024: {
					slidesPerView: 3,
					spaceBetween: 30,
				},
			},
		}
	)
	var slideCuisinePagination = new Swiper('.section-cuisine-page .swiper', {
		slidesPerView: 1,
		spaceBetween: 15,
		modules: [Pagination],
		pagination: {
			el: '.swiper-pagination',
			clickable: true,
			renderBullet: (index, className) => {
				return `<div class="${className}">${index + 1}</div>`
			},
		},
	})
	// Trigger Pagination
	$('.section-cuisine-page .swiper-pagination-bullet').on('click', function () {
		$('html,body').animate(
			{
				scrollTop: $('.section-cuisine-page').offset().top,
			},
			1000
		)
	})
	var factoryThumb = new Swiper('.factory-1 .slide-thumb .swiper', {
		slidesPerView: 3,
		spaceBetween: 10,
		autoplay: {
			delay: 1500,
		},
		speed: 300,
		breakpoints: {
			575: {
				spaceBetween: 30,
				slidesPerView: 3,
			},
			1024: {
				spaceBetween: 30,
				slidesPerView: 4,
			},
		},
	})
	var factoryMain = new Swiper('.factory-1 .slide-main .swiper', {
		spaceBetween: 10,
		modules: [Thumbs, Navigation],
		speed: 500,
		navigation: {
			nextEl: '.factory-1 .slide-thumb .btn-next',
			prevEl: '.factory-1 .slide-thumb .btn-prev',
		},
		slidesPerView: 1,
		thumbs: {
			swiper: factoryThumb,
		},
	})
	var factoryThumb = new Swiper('.factory-3 .swiper', {
		slidesPerView: 1.5,
		spaceBetween: 30,
		modules: [Navigation],
		navigation: {
			nextEl: '.factory-3 .btn-next',
			prevEl: '.factory-3 .btn-prev',
		},
		breakpoints: {
			575: {
				spaceBetween: 30,
				slidesPerView: 3,
			},
			1024: {
				spaceBetween: 32,
				slidesPerView: 4,
			},
		},
	})
}
